import './form-error.scss';

import { components } from 'gridstrap/lib/gs-components';
import { GSFormError } from './form-error';

components.register({
	selector: '.gs-FormError',
	controller: GSFormError
});
